const DOLLAR_SIGN = "$";
const THOUSANDS_SEPARATOR_REGEX = /,/g;

const getAmountValueFromCurrency = (value: string): string => {
  const amount = value
    .replace(DOLLAR_SIGN, "")
    .replace(THOUSANDS_SEPARATOR_REGEX, "");

  return amount;
};

export default getAmountValueFromCurrency;
